<template>
  <div>
    <v-navigation-drawer
      :mini-variant="mini"
      mini-variant-width="60px"
      :expand-on-hover="expandOnHover"
      permanent="permanent"
      app
      dark
      v-if="!mobile || drawer">
      <v-list dense>
        <v-list-item v-for="(item, i) in sidebarItems" :key="i" :to="item.link">
          <v-list-item-action>
            <v-tooltip right color="pink">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">{{ item.icon }}</v-icon>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="userIsAdmin()">
           <v-list-item-action>
             <v-menu offset-x :nudge-width="150" right rounded="0" open-on-hover>
              <template v-slot:activator="{ on: menu, attrs }">
                <v-icon v-bind="attrs" v-on="{...menu}">mdi-apps</v-icon><!--mdi-dots-grid-->
              </template>
              <v-list dense>
                <v-subheader>Ver más opciones</v-subheader>
                <v-list-item v-for="(menuItem, idx) in hoverMenuItems" :key="idx" :to="menuItem.link">
                   <v-list-item-icon>
                    <v-icon v-text="menuItem.icon"></v-icon>
                  </v-list-item-icon>
                   <v-list-item-content>
                     <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
                   </v-list-item-content>
                </v-list-item>
              </v-list>
             </v-menu>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Ver más</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-list-item 
          class="mb-3"
          v-show="user"
          @click="showConfirmLogout = true">
          <v-list-item-action>
            <v-tooltip right color="pink">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">mdi-logout</v-icon>
              </template>
              <span>Salir</span>
            </v-tooltip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>
    <v-dialog 
      max-width="350"
      :value="showConfirmLogout">
      <v-card>
        <v-card-title class="red--text">
          ¿Cerrar sesión?
        </v-card-title>
        <v-card-subtitle class="mt-3">
          Por favor confirma que quieres cerrar tu sesión.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showConfirmLogout = false">
            No
          </v-btn>
          <v-btn color="red darken-1" text @click="logOut">
            Sí
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
export default {
  name: "Sidebar",
  data: () => ({
    drawer: null,
    mini: true,
    confirmLogout: false,
    permanent: true,
    expandOnHover: false,
    mobile: false,
    hoverMenuItems: [
      {
        title: "Usuarios",
        icon: "mdi-badge-account-outline",
        link: "/usuarios",
      },
      { title: "Servicios", icon: "mdi-tumble-dryer", link: "/servicios" },
      { title: "Productos", icon: "mdi-hanger", link: "/productos" },
      { title: "Categorias", icon: "mdi-lan", link: "/categorias" },//mdi-graph
      { title: "Promos", icon: "mdi-sale", link: "/promos" },
      { title: "Reportes", icon: "mdi-chart-bar-stacked", link: "/reportes" },
      // { title: "Administración", icon: "mdi-contacts", link: "/admin" },
      { title: "Configuración", icon: "mdi-cog", link: "/config" },
    ],
    sidebarItems: [
      { title: "Inicio", icon: "mdi-home", link: "/" },
      { title: "Crear Venta", icon: "mdi-tshirt-crew", link: "/venta" },
      { title: "Cobrar | Entregar | Inventariar", icon: "mdi-clipboard-text-search-outline", link: "/inventario" },//mdi-playlist-check
      {
        title: "Pendientes: Por Lavar | Por Doblar",
        icon: "mdi-timer-sand",
        link: "/servicios-pendientes",
      },
      {
        title: "Sevicios Entregados",
        icon: "mdi-checkbox-marked-circle-outline",
        link: "/entregados",
      },
      { title: "Caja | Arqueo | Movimientos", icon: "mdi-cash-register", link: "/caja" },
      { title: "Ventas", icon: "mdi-finance", link: "/ventas" },
      { title: "Clientes", icon: "mdi-contacts", link: "/clientes" },
      
    ],
  }),
  computed: {
    ...mapGetters(['user']),
    showConfirmLogout: {
      get: function() {
        return this.confirmLogout && this.user;
      },
      set: function(confirmation) {
        this.confirmLogout = confirmation;
      }
    }
  },
  methods: {
    ...mapActions(['logUserOut']),
    userIsAdmin(){
      const user = this.user;
      return user && user.perfil == "Administrador";
    },
    logOut(){
      if (this.user) {
        this.logUserOut();
        this.$router.push('/login');
        this.showConfirmLogout = false;
      }
    }
  },
};
</script>